export interface FeesTooltipFormatterResult {
  title: string;
  cells: string[];
}

export const feesTooltipFormatter = (tooltipText: string): FeesTooltipFormatterResult => {
  // tooltip text would be the following formats
  // some_name;
  // some_name;1,1,1,1
  // some_name;Annual,20.00
  const titleAndCells = tooltipText.split(';');
  const cellsString = titleAndCells[1].split(',');
  let cells: string[] = [];
  if (cellsString.length === 1 && cellsString[0] === '') {
    cells = [];
  } else if (cellsString.length === 2) {
    cells = [cellsString[0], Number(cellsString[1]).toFixed(2)];
  } else {
    cells = cellsString.map((cell) => Number(cell).toFixed(2));
  }

  return {
    title: titleAndCells[0],
    cells,
  };
};
